import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export const useApi = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const apiFetch = useCallback(async (url, options = {}) => {
    const token = localStorage.getItem("adminToken");

    const headers = {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    };

    if (token) {
      headers["Authorization"] = `Bearer ${token}`;
    }

    const res = await fetch(url, { ...options, headers });

    if (res.status === 401) {
      logout();
      navigate("/admin");
      throw new Error("Session expired. Redirecting to login...");
    }

    if (res.status === 403) {
      throw new Error("Permission denied. You do not have access.");
    }

    return res;
  }, [logout, navigate]);

  return { apiFetch };
};
